<template>
  <div>
    <el-radio-group v-model="path"  size="medium" @change="tabPath">
      <el-radio-button label="/recipeStatistics/drugInventory/stocks">药品总库存</el-radio-button>
      <el-radio-button label="/recipeStatistics/drugInventory/stockUp">药品备货库存</el-radio-button>
    </el-radio-group>
    <div style="margin-top: 20px">
      <keep-alive>
        <router-view v-if='$route.meta.keepAlive'></router-view>
      </keep-alive>
      <router-view v-if='!$route.meta.keepAlive'></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "anomaly",
  data() {
    return {
      path: "/recipeStatistics/drugInventory/stocks"
    }
  },
  created() {
    this.path=this.$route.path
  },
  component: {
    //someComponent
  },
  methods: {
    //
    tabPath(){
      this.$router.push(this.path)
    }
  },
  mounted() {
    //
  }
}
</script>

<style lang="scss" scoped>
.index {

}
</style>